import '@giftie/corporate-designer/style.css'
import PHProvider from '@/components/providers'
import AppBridgeProvider from '@/components/providers/AppBridgeProvider'
import type { AppProps } from 'next/app'

const App = ({ Component, pageProps }: AppProps) => {
  return (
    <>
      <PHProvider>
        <AppBridgeProvider>
          {/* @ts-ignore */}
          <Component {...pageProps} />
        </AppBridgeProvider>
      </PHProvider>
    </>
  )
}

export default App
